var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col" },
    [
      _vm.prescriptions.length > 0 && _vm.medCode === "chmedPrescriptionItem"
        ? _c(
            "div",
            { staticClass: "description-con" },
            [
              _c(
                "el-descriptions",
                { attrs: { border: "", column: 2 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "剂数" } }, [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.head["doseNum"])),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "天数" } }, [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.head["dayNum"])),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "次/日" } }, [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.head["dayDoseNum"])),
                    ]),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "剂/日" } }, [
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.head["dayFreq"])),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.prescriptions.length > 0
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.info.body[_vm.medCode],
                border: "",
                "header-row-class-name": "header-row",
                "header-cell-class-name": "header-row",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "materielName", label: "药品", align: "center" },
              }),
              _vm.medCode === "chmedPrescriptionItem"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "singleNum",
                      label: "数量",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm.medCode === "medPrescriptionItem"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "sellingNum",
                      label: "数量",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm.medCode === "agentPrescriptionItem"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "sellingNum",
                      label: "数量",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm.medCode === "chagentPrescriptionItem"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "sellingNum",
                      label: "数量",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm.medCode === "servePrescriptionItem"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "sellingNum",
                      label: "数量",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _vm.medCode === "chmedPrescriptionItem"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "decoctionName",
                      label: "煎法",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "meaUomName", label: "单位", align: "center" },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }